import {
    StyledFinalStepModalBtnWrapper,
    StyledFinalStepModalDescription,
    StyledFinalStepModalSubDescription,
    StyledFinalStepModalTitle,
    StyledIconWrapper,
    StyledModalFinalStep,
    StyledUserApproveIcon,
    StyledUserApproveLink,
} from "./styles";
import { Button } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";

type ModalContentUserApprovedProps = {
    title: string;
    description: string;
    subDescription?: string;
    onClick: () => void;
    buttonText: string;
};

const ModalContentUserApproved: FC<ModalContentUserApprovedProps> = ({
    title,
    description,
    subDescription,
    buttonText,
    onClick,
}) => {
    return (
        <StyledModalFinalStep>
            <StyledIconWrapper>
                <SWReactIcons
                    iconName="fire-colored"
                    size={"xxl"}
                />
            </StyledIconWrapper>
            <StyledFinalStepModalTitle>{title}</StyledFinalStepModalTitle>
            <StyledFinalStepModalSubDescription>{subDescription}</StyledFinalStepModalSubDescription>
            <StyledFinalStepModalDescription dangerouslySetInnerHTML={{ __html: description }} />
            <StyledFinalStepModalBtnWrapper>
                <Button
                    type="primary"
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            </StyledFinalStepModalBtnWrapper>
            <StyledUserApproveLink
                href={"https://support.similarweb.com/hc/en-us/articles/14234221556509"}
                target={"_blank"}
            >
                {translate("si.signals.traffic-changes.learnMore")}
                <StyledUserApproveIcon
                    iconName="link-out"
                    size="xs"
                />
            </StyledUserApproveLink>
        </StyledModalFinalStep>
    );
};

export default ModalContentUserApproved;
